import { Link } from "react-router-dom";
import Login from 'pages/Auth/Login';
// import { AppContext } from "AppContext";
import { oauthClient } from "Auth";

let refreshingToken = false
let tokenRefreshPromise = null

const axios = require("axios");

// const { oauthToken, setOauth } = useContext(AppContext);
const config = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem("accessToken")}`,
    'Access-Control-Allow-Origin': '*'
  },
};

export function tokenRefreshed(callback) {
  console.log("HERE===============: ");
  // debugger
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  let oauthToken = oauthClient.createToken(accessToken, refreshToken, "bearer");

  oauthToken
    .refresh()
    .then((res) => {
      // debugger;
      localStorage.setItem("accessToken", res.data.access_token);
      localStorage.setItem("refreshToken", res.data.refresh_token);
      config.headers.Authorization = `Bearer ${res.data.access_token}`;
      callback();
    })
    .catch((err) => {
      // debugger;
    });
}

const getRefreshToken = () => {
  refreshingToken = true
  // debugger
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  let oauthToken = oauthClient.createToken(accessToken, refreshToken, "bearer");

  let refreshPromise = oauthToken
    .refresh()
    .then((res) => {
      // debugger;
      localStorage.setItem("accessToken", res.data.access_token);
      localStorage.setItem("refreshToken", res.data.refresh_token);
      config.headers.Authorization = `Bearer ${res.data.access_token}`;
      refreshingToken = false
    })
    .catch((err) => {
      // debugger;
    });

  tokenRefreshPromise = refreshPromise;
  return refreshPromise;
};

export function apiGet(url, header) {
  let c = Object.assign({}, config);
  if (header) {
    if (header.headers) {
      c.headers = Object.assign({}, c.headers, header.headers)
    }
    else {
      c = Object.assign({}, c, header)
    }
  }

  // const { oauthToken, setOauth } = useContext(AppContext);
  return axios
    .get(url, c)

    .then((response) => {
      return response;
    })
    .catch(function (error) {
      // debugger
      // console.log("ERROR RESPONSE:", error);

      if (error && error.response && error.response.status === 401) {
        // localStorage.clear();
        //tokenRefreshed(apiGet(url));
        // debugger;
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken == null) {
          window.location.href = "/login";
          return Promise.reject(error);
        }
        else {
          let performRefresh = false
          if (refreshingToken) {
            if (tokenRefreshPromise) {
              tokenRefreshPromise.then(() => {
                return new Promise(function (resolve, reject) {
                  resolve(apiGet(url))
                })
              }
              )
                .catch((err) => {
                  localStorage.clear();
                  //<Login />
                  window.location.href = "/login";
                  return Promise.reject(error);
                })
            }
            else {
              performRefresh = true
            }
          }
          else {
            performRefresh = true
          }
          if (performRefresh) {
            getRefreshToken().then(() => {
              return new Promise(function (resolve, reject) {
                resolve(apiGet(url))
              })
            })
              .catch((err) => {
                localStorage.clear();
                //<Login />
                window.location.href = "/login";
                return Promise.reject(error);
              })
          }
        }
      }
      // specific error handling done elsewhere
      return Promise.reject(error);

    });
}

export function apiPost(url, data, header) {
  let c = Object.assign({}, config);
  if (header) {
    if (header.headers) {
      c.headers = Object.assign({}, c.headers, header.headers)
    }
    else {
      c = Object.assign({}, c, header)
    }
  }

  return axios
    .post(url, data, c)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      //debugger
      if (error && error.response && error.response.status === 401) {

        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken == null) {
          window.location.href = "/login";
          return Promise.reject(error);
        }
        else {
          let performRefresh = false
          //console.log('refreshingToken')
          //console.log(refreshingToken)
          if (refreshingToken) {
            if (tokenRefreshPromise) {
              tokenRefreshPromise.then(() => {
                return new Promise(function (resolve, reject) {
                  resolve(apiPost(url, data));
                })
              }
              )
                .catch((err) => {
                  localStorage.clear();
                  //<Login />
                  window.location.href = "/login";
                  return Promise.reject(error);
                })
            }
            else {
              performRefresh = true
            }
          }
          else {
            performRefresh = true
          }
          if (performRefresh) {
            getRefreshToken().then(() => {
              return new Promise(function (resolve, reject) {
                resolve(apiPost(url, data));
              })
            })
              .catch((err) => {
                localStorage.clear();
                //<Login />
                window.location.href = "/login";
                return Promise.reject(error);
              })
          }
        }

      }

      return Promise.reject(error);
    });
}



export function apiDelete(url,
  data,//not being used, we should implement this later
  header) {
  let c = Object.assign({}, config);
  if (header) {
    if (header.headers) {
      c.headers = Object.assign({}, c.headers, header.headers)
    }
    else {
      c = Object.assign({}, c, header)
    }
  }

  return axios
    .delete(url,
      //data, not taking data, data need to be wrap in to option with {data: datajson}
      c)
    .then((response) => {
      return response;
    })
    .catch(function (error) {
      //  debugger
      if (error && error.response && error.response.status === 401) {
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken == null) {
          window.location.href = "/login";
          return Promise.reject(error);
        }
        else {
          let performRefresh = false
          if (refreshingToken) {
            if (tokenRefreshPromise) {
              tokenRefreshPromise.then(() => {
                return new Promise(function (resolve, reject) {
                  resolve(apiDelete(url, data));
                })
              }
              )
                .catch((err) => {
                  localStorage.clear();
                  //<Login />
                  window.location.href = "/login";
                  return Promise.reject(error);
                })
            }
            else {
              performRefresh = true
            }
          }
          else {
            performRefresh = true
          }
          if (performRefresh) {
            getRefreshToken().then(() => {
              return new Promise(function (resolve, reject) {
                resolve(apiDelete(url, data));
              })
            })
              .catch((err) => {
                localStorage.clear();
                //<Login />
                window.location.href = "/login";
                return Promise.reject(error);
              })
          }
        }
      }
      return Promise.reject(error);
    });
}